export default "__VITE_ASSET__DCGohmS0__"